import { Container } from '@sainsburys-tech/luna-grid'
import { Button } from '@sainsburys-tech/luna-button'
import { useState } from 'react'
import PromptComponent from '../Reporting/ComponentSwitch/Components/PromptComponent'
import { useNavigate } from 'react-router'

const ReportEnforcementContact = () => {
  const navigateTo = useNavigate()
  const [showPrompt, setShowPrompt] = useState(false)

  const clearSessionData = () => {
    ['draftId', 'investigationId'].forEach((key) => sessionStorage.removeItem(key));
    sessionStorage.setItem('enforcementContact', sessionStorage.getItem('enforcementContact') === 'true' ? 'false' : 'false');
  };

  const handleOnClick = () => {
    clearSessionData()
    setShowPrompt(true)
  }

  function createEnforcementContact() {
    clearSessionData()
    sessionStorage.setItem('enforcementContact', 'true')
    navigateTo('/reporting')
  }

  function handlePromptResponse(response: boolean) {
    setShowPrompt(false)
    if (response) {
      createEnforcementContact()
    }
  }

  return (
    <>
      {showPrompt && (
        <PromptComponent
          title={'Report a new enforcement contact'}
          body={'Would you like to report a new enforcement contact?'}
          text={'Yes'}
          icon={'BlueInfoIcon'}
          classification=""
          handleResult={handlePromptResponse}
        />
      )}

      <Container className="ln-u-padding-ends*3" size="xs">
        <Button
          id="s-report-safety-enforcement-contact"
          className="ln-u-bg-color-white report-button report-button-mobile"
          variant="outlined"
          disabled={false}
          element="button"
          onClick={handleOnClick}
        >
          Report an enforcement contact
        </Button>
      </Container>
    </>
  )
}

export default ReportEnforcementContact
